import React from 'react';
import { QuoteStatus } from '../types';

interface StatusBadgeProps {
  status: QuoteStatus;
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
  const getStatusStyles = () => {
    switch (status) {
      case 'OPEN':
        return 'bg-accent/10 text-accent border-accent/20';
      case 'APPROVED':
        return 'bg-success/10 text-success border-success/20';
      case 'CANCELLED':
        return 'bg-muted text-text-secondary border-border';
      default:
        return 'bg-muted text-text-secondary border-border';
    }
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium border ${getStatusStyles()} ${className}`}
    >
      {status}
    </span>
  );
};

export default StatusBadge;